import { jordanDate } from '@serb/shared';
import { monthStart, weekStart } from './dates';

export const PERIODS = ['Today', 'This Week', 'This Month', 'This Year'] as const;
export type Period = (typeof PERIODS)[number];

/** Is this date (YYYY-MM-DD) inside the chosen period, counted from today? */
export function inPeriod(date: string, period: Period): boolean {
  const today = jordanDate();
  if (date > today) return false;
  if (period === 'Today') return date === today;
  if (period === 'This Week') return date >= weekStart(today);
  if (period === 'This Month') return date >= monthStart(today);
  return date.slice(0, 4) === today.slice(0, 4);
}
